import { createSelector } from "reselect";
import { RootState } from "RootReducer";

export const getIsParcelListLoading = createSelector(
  (state: RootState) => state.loading.loaders,
  (loaders) => loaders.includes("LOAD_PARCEL_LIST")
);
